const withDefaultPrevented = callback => ev => {
  ev.preventDefault();
  callback();
};

export default withDefaultPrevented;
